import React, { useState, useEffect }  from 'react'
import { Table,  Space } from 'antd'
import Main from '../../../cpn/Main';
import InvoiceNodeDel from './InvoiceNodeDel';
import InvoiceNodeAdd from './InvoiceNodeAdd';
import InvoiceNodeCheck from './InvoiceNodeCheck';
import InvoiceNodeCopyAdd from './InvoiceNodeCopyAdd';
import { useKPSQspjdListQuery } from '../../../store/DianShangYeWuApi';
function InvoiceNodeList() {
    const qy_id = JSON.parse(localStorage.getItem('jtg-caiwu_qy_id'))
    const qy_name = JSON.parse(localStorage.getItem('jtg-caiwu_qy_name'))
    const yh_id = JSON.parse(localStorage.getItem('jtg-caiwu_yh_id'))
    const yh_name = JSON.parse(localStorage.getItem('jtg-caiwu_yh_name'))
    const {data, isSuccess} = useKPSQspjdListQuery({kpsq_spjd_qy_id:qy_id});
    const [list, setList] = useState();
    useEffect(() => {
        if(isSuccess && data.Status === 'success' && data.Result){            
            // 找出所有不同的kpsq_spjd_user_id并合并
            const mergedArr = [];
            const userMap = {};
            data.Result.forEach(item => {
                // 用kpsq_spjd_user_id去合并
                if (item.kpsq_spjd_user_id && !userMap[item.kpsq_spjd_user_id]) {
                    userMap[item.kpsq_spjd_user_id] = {
                        key: item.kpsq_spjd_user_id,
                        kpsq_spjd_user_id: item.kpsq_spjd_user_id,
                        kpsq_spjd_user_name: item.kpsq_spjd_user_name,
                        kpsq_spjd_name: item.kpsq_spjd_name,
                        kpsq_spjd_yh_id: item.kpsq_spjd_yh_id,
                        kpsq_spjd_yh_name: item.kpsq_spjd_yh_name,
                        yh_id: item.kpsq_spjd_yh_id,
                        yh_name: item.kpsq_spjd_yh_name,
                    }
                    mergedArr.push(userMap[item.kpsq_spjd_user_id])
                }
            })
            setList(mergedArr);
        }else{
            setList([]);
        }
    }, [data, isSuccess])
    const columns = [
        {
            title: '开票申请操作员',
            dataIndex: 'kpsq_spjd_user_name',
            key: 'kpsq_spjd_user_name',
            width: 300, 
            render: (text, record) => <Space>
                <InvoiceNodeCheck
                    user_id={record.kpsq_spjd_user_id}
                    user_name={record.kpsq_spjd_user_name}
                    qy_id={qy_id}
                    qy_name={qy_name}
                    yh_id={yh_id}
                    yh_name={yh_name}
                    kpsq_spjd_user_id={record.kpsq_spjd_user_id}
                    kpsq_spjd_user_name={record.kpsq_spjd_user_name}
                />
            </Space>
        },
        {
            title: '操作',
            key: 'action',
            render: (text, record) => <Space size={20}>
                <InvoiceNodeDel
                    kpsq_spjd_user_id={record.kpsq_spjd_user_id}                    
                />
                <InvoiceNodeCopyAdd
                    kpsq_spjd_user_id={record.kpsq_spjd_user_id}  
                    qy_id={qy_id}
                    qy_name={qy_name}
                    yh_id={yh_id}
                    yh_name={yh_name}
                />
            </Space>
        },
    ]
    return (
        <Main selectedKeys={['/InvoiceNodeList']}>
            <InvoiceNodeAdd  
                qy_id={qy_id}
                qy_name={qy_name}
                yh_id={yh_id}
                yh_name={yh_name}
            />
            <Table
                columns={columns}
                dataSource={list}
                style={{marginTop:'10px',width:'500px'}}
                className="custom-table"
                size='small'
                bordered
                rowKey="key"
            />
        </Main>
    )
}

export default InvoiceNodeList